import React from 'react';
import { Skeleton } from '@shared/components/Skeleton';
import { Box, Flex, SpacingStack } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

const INPUT_BORDER_RADIUS = 2;

export const CreateWeddingFormSkeleton: React.FC = () => {
  return (
    <Box
      width={'100%'}
      marginTop={5}
    >
      <SpacingStack
        spacing={5}
        width="100%"
        alignItems="center"
        marginTop={5}
      >
        <Skeleton
          height={pxToRem(34)}
          width="80%"
          borderRadius={INPUT_BORDER_RADIUS}
        />
        <Skeleton
          height={pxToRem(16)}
          width="60%"
          borderRadius={INPUT_BORDER_RADIUS}
        />
      </SpacingStack>

      <SpacingStack
        spacing={6}
        width="100%"
        marginTop={2}
      >
        <SpacingStack spacing={2}>
          <Box height={pxToRem(14)} />
          <Skeleton
            height={pxToRem(50)}
            width="100%"
            borderRadius={INPUT_BORDER_RADIUS}
          />
        </SpacingStack>

        <SpacingStack spacing={2}>
          <Box height={pxToRem(14)} />
          <Skeleton
            height={pxToRem(50)}
            width="100%"
            borderRadius={INPUT_BORDER_RADIUS}
          />
        </SpacingStack>

        <SpacingStack spacing={5}>
          <SpacingStack spacing={2}>
            <Box height={pxToRem(14)} />
            <Skeleton
              height={pxToRem(56)}
              width="100%"
              borderRadius={INPUT_BORDER_RADIUS}
            />
          </SpacingStack>
          <Flex
            gap={3}
            flexDirection="row"
            alignItems="center"
          >
            <Skeleton
              height={pxToRem(20)}
              width={pxToRem(36)}
              borderRadius={pxToRem(12)}
            />
            <Skeleton
              height={pxToRem(14)}
              width={pxToRem(190)}
              borderRadius={INPUT_BORDER_RADIUS}
            />
          </Flex>
        </SpacingStack>

        <SpacingStack spacing={5}>
          <SpacingStack spacing={2}>
            <Box height={pxToRem(14)} />
            <Skeleton
              height={pxToRem(56)}
              width="100%"
              borderRadius={INPUT_BORDER_RADIUS}
            />
          </SpacingStack>
          <Flex
            gap={3}
            flexDirection="row"
            alignItems="center"
          >
            <Skeleton
              height={pxToRem(20)}
              width={pxToRem(36)}
              borderRadius={pxToRem(12)}
            />
            <Skeleton
              height={pxToRem(14)}
              width={pxToRem(210)}
              borderRadius={INPUT_BORDER_RADIUS}
            />
          </Flex>
        </SpacingStack>
      </SpacingStack>

      <SpacingStack
        spacing={6}
        width="100%"
        marginTop={6}
        alignItems="center"
      >
        <Skeleton
          height={pxToRem(52)}
          width="100%"
          borderRadius={pxToRem(28)}
        />
        <Skeleton
          height={pxToRem(18)}
          width="70%"
          borderRadius={INPUT_BORDER_RADIUS}
        />
      </SpacingStack>
    </Box>
  );
};

export default CreateWeddingFormSkeleton;
